export const TAGS_OPEN_CREATE_EDIT_MODAL = "TAGS_OPEN_CREATE_EDIT_MODAL";

export const TAGS_SAVE_TAG = "TAGS_SAVE_TAG";
export const TAGS_SAVE_TAG_RESPONSE = "TAGS_SAVE_TAG_RESPONSE";

export const TAGS_GET_TAG = "TAGS_GET_TAG";
export const TAGS_GET_TAG_RESPONSE = "TAGS_GET_TAG_RESPONSE";

export const TAGS_GET_ENTITIES = "TAGS_GET_ENTITIES";
export const TAGS_GET_ENTITIES_RESPONSE = "TAGS_GET_ENTITIES_RESPONSE";